'use strict';
import Relay from 'system/relay'
import App from 'system/app'

export default {
  props: ['userLabel','userPlaceholder','userIcon'],
  data (){
    let params = Relay.getRedirectParams()
    if(params===null)
      params = []
    // allow us to override the redirect params (for auth chaining)
    if(typeof(this.$route.query.state)!=="undefined"){
      params.state = this.$route.query.state
      params.redirect_uri = this.$route.query.redirect_uri
    }
    if(!(params && params.state)){
      Relay.get("SecureUser",{},function(response){
        this.continue() // we were already logged in
      })
    }
    return {
      auth: {},
      params:params
    }
  },
  methods: {
    login: function(){
      var auth = this.auth
      auth.act = "authenticate"
      auth.dt_ck = "alias,password"
      auth.state = this.params.state
      auth.redirect_uri = this.params.redirect_uri
      //auth.svc = $stateParams.service // required for SSO
      //auth.tgt = $scope.target_api

      // do not attempt to request a relay token atm (interferes with chained login)
      Relay.save("Login",auth,
        (rsp)=>{
          // let the attempted redirect be our guide
          let m = rsp.match(/<script>window.location.href='([^']+)'<\/script>/)
          if(m){
            var here_url = window.location.host
            let tgt_url = new URL(m[1])
            if(here_url != tgt_url.host)
              window.location.replace(m[1])
          }
          this.continue()
        },
        (err)=>{
          this.$refs.auth_failed.show()
        }
      )
    },

    continue: function(default_url){
      var protected_url = localStorage.getItem("protected_url")
      this.$router.push(protected_url?protected_url:"/")
    }
  }
}
